export { filterSeparateColorDiscriminant } from './filterSeparateColorDiscriminant';
export { getCollectionProductInfo } from './getCollectionProductInfo';
export { getColorAlternatives, getPopoverText } from './getColorAlternatives';
export { getCurrentProductValues } from './getCurrentProductValues';
export * from './getDiscount';
export { getProductsWithCurrentColor } from './getProductsWithCurrentColor';
export { matchPropertyValues } from './matchPropertyValues';
export { shouldShowCollection } from './shouldShowCollection';
